<template>
  <div>
    <div class="content">
      <span class="heading has-divider is-size-5 has-text-weight-bold has-text-primary">
        Order Quote Financials
      </span>
    </div>
    <div class="level is-mobile">
      <div class="level-left">
        <div class="level-item">
          <span class="has-text-grey has-text-weight-bold">
            Create
          </span>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <b-field>
            <b-switch
              type="is-info"
              v-model="create"
            />
          </b-field>
        </div>
      </div>
    </div>

    <div class="level is-mobile">
      <div class="level-left">
        <div class="level-item">
          <span class="has-text-grey has-text-weight-bold">
            Edit
          </span>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <b-field>
            <b-switch
              type="is-info"
              v-model="edit"
            />
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: 'PermissionsOrderQuoteFinancialsForm',

  computed: {
    create: {
      get() {
        return this.$store.state.Permissions.permissions.order_quote_financials.create;
      },

      set(value) {
        return this.$store.commit('Permissions/SET_ORDER_QUOTE_FINANCIALS_CREATE_PERMISSIONS', value);
      },
    },

    edit: {
      get() {
        return this.$store.state.Permissions.permissions.order_quote_financials.edit;
      },

      set(value) {
        return this.$store.commit('Permissions/SET_ORDER_QUOTE_FINANCIALS_EDIT_PERMISSIONS', value);
      },
    },
  },
};
</script>

<style lang="css" scoped>
</style>
